import {
    ChangeDetectionStrategy,
    ViewEncapsulation,
    Component,
    Input,
    inject,
    input,
    ElementRef,
    computed,
} from '@angular/core';
import { IUserActivationDateFilter } from './fi-onboarding-user-activation-date-filter/fi-onboarding-user-activation-date-filter.component';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { IOnboardingEditItem } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding';
import { IAccessRightCoreFilter } from '@fi-shared/models';
import { FiOnboardingBuilderStoreService } from '../../../fi-onboarding-builder-store.service';

@Component({
    selector: 'fi-onboarding-sharing-settings',
    templateUrl: './fi-sharing-settings.component.html',
    styleUrls: ['./fi-sharing-settings.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-onboarding-sharing-settings', '[class.hidden]': 'hidden()' },
    standalone: false,
    providers: [{ provide: FiComponentsContainer, useExisting: FiOnboardingSharingSettingsComponent }],
})
export class FiOnboardingSharingSettingsComponent extends FiComponentsContainer {
    @Input() scrollableElementRefs: ElementRef<HTMLElement>[];
    public readonly hidden = input<boolean>(false);

    private readonly fiOnboardingBuilderStoreService = inject(FiOnboardingBuilderStoreService);

    protected onboarding = computed<IOnboardingEditItem>(() =>
        this.fiOnboardingBuilderStoreService.currentOnboarding(),
    );
    protected isShared = computed<boolean>(() => this.onboarding()?.IsShared);
    protected onboardingAccessRightCoreFilter = computed<IAccessRightCoreFilter>(() => {
        return this.onboarding().AccessRightFilterCollection.AccessRightCoreFilter;
    });
    protected activationDateFilterValue = computed<IUserActivationDateFilter>(() => {
        return {
            FilterUsersByActivationDate: this.onboarding()?.FilterUsersByActivationDate ?? false,
            UserActivationDate: this.onboarding()?.UserActivationDate,
        };
    });

    protected onSharingChange(isShared: boolean): void {
        this.fiOnboardingBuilderStoreService.updateCurrentOnboarding((currentValue) => {
            return {
                ...currentValue,
                IsShared: isShared,
                IsActive: !isShared ? false : currentValue.IsActive,
            };
        });
    }

    protected onActivationDateFilterChange(newActivationDateFilter: IUserActivationDateFilter): void {
        this.fiOnboardingBuilderStoreService.updateCurrentOnboarding((currentValue) => {
            return {
                ...currentValue,
                FilterUsersByActivationDate: newActivationDateFilter.FilterUsersByActivationDate,
                UserActivationDate: newActivationDateFilter.UserActivationDate,
            };
        });
    }

    protected onAccessRightCoreFilterChange(accessRightCoreFilter: IAccessRightCoreFilter): void {
        this.fiOnboardingBuilderStoreService.updateCurrentOnboarding((currentValue) => {
            return {
                ...currentValue,
                AccessRightFilterCollection: {
                    ...currentValue.AccessRightFilterCollection,
                    AccessRightCoreFilter: accessRightCoreFilter,
                },
            };
        });
    }
}
